import { atom } from "jotai";

import { groupRestrictionsAtom, roundRestrictionsAtom } from "../../stores";
import { isFormDirtyAtom } from "../isFormDirtyAtom/isFormDirtyAtom";

export const canBookingSaveAtom = atom((get) => {
  const isFormDirty = get(isFormDirtyAtom);
  const roundRestrictions = get(roundRestrictionsAtom);
  const groupRestrictions = get(groupRestrictionsAtom);

  const hasViolatingRoundRestrictions = roundRestrictions.some(
    (rounds) =>
      rounds.some(
        (restriction) =>
          restriction.willViolate && restriction.rule.memberOverride === "NONE"
      ) ?? false
  );
  const hasViolatingGroupRestrictions =
    groupRestrictions?.some(
      (restriction) =>
        restriction.willViolate && restriction.rule.memberOverride === "NONE"
    ) ?? false;

  if (
    hasViolatingRoundRestrictions ||
    hasViolatingGroupRestrictions ||
    !isFormDirty
  ) {
    return false;
  }
  return true;
});
